export const EmployeeDispatchFilters = {
    OnCall: 'Available for On Call',
    ExpandedSearch: 'Expand Search Radius',
};